// /frontend/src/services/api/admin.js
import api from '@/services/api';

export const adminApi = {
  getOverview(params = { date: null }) {
    const q = new URLSearchParams();
    if (params.date) q.set('date', params.date);
    return api.get(`/admin/overview?${q.toString()}`);
  },

  // Autovervollständigung für Schülernamen
  searchStudents(params = { q: '' }) {
    const q = new URLSearchParams();
    if (params.q) q.set('q', params.q);
    return api.get(`/admin/students/search?${q.toString()}`);
  },

  // Status eines Schülers anhand des Namens abrufen
  getStudentStatus(params = { name: '' }) {
    const q = new URLSearchParams();
    if (params.name) q.set('name', params.name);
    return api.get(`/admin/student/status?${q.toString()}`);
  },

  // Change Logs (Admin) mit Filtern
  getChangeLogs(params = {}) {
    const q = new URLSearchParams();
    if (params.userId != null && params.userId !== '') q.set('userId', String(params.userId));
    if (params.user) q.set('user', params.user);
    if (params.area) q.set('area', params.area);
    if (params.context) q.set('context', params.context);
    if (params.dateFrom) q.set('dateFrom', params.dateFrom);
    if (params.dateTo) q.set('dateTo', params.dateTo);
    if (params.page) q.set('page', String(params.page));
    if (params.perPage) q.set('perPage', String(params.perPage));
    return api.get(`/admin/change-logs?${q.toString()}`);
  },

  // Geburtstage: heute und in den nächsten X Tagen
  getBirthdays(params = { date: null, daysAhead: 7, activeOnly: true }) {
    const q = new URLSearchParams();
    if (params.date) q.set('date', params.date);
    if (params.daysAhead != null) q.set('daysAhead', String(params.daysAhead));
    if (params.activeOnly != null) q.set('activeOnly', params.activeOnly ? '1' : '0');
    return api.get(`/admin/birthdays?${q.toString()}`);
  }
};
